export const manageButtonProperties = {
  class: "neutral",
  isEnabled: true,
  icon: "add",
};
